import React from 'react';
import { InputItem } from 'antd-mobile';

class Remark extends React.Component{
    render(){
        let {api_name, is_required, checked, form} = this.props;
        const {getFieldProps, getFieldError} = form;
        
        let tempProps = {
            name: api_name,
            placeholder: $st('请输入多选备注')
        };
        let fieldProps = getFieldProps(api_name, {
            initialValue: '',
            validate: [{
                trigger: 'onChange',
                rules: [{
                    required: is_required,
                    message: $st(`该项是必填项`)
                },{
                    pattern: /[^\s]+/,
                    message: '不能为空',
                }]
            }]
        });
        let errorText = getFieldError(api_name);

        return (
            <div className="remark-wrap">
                <InputItem {...tempProps} {...fieldProps} />
                {checked && errorText && <div className='input-error remark-input-error'>{errorText}</div>}
            </div>
        )
    }
}
export default Remark;


// WEBPACK FOOTER //
// ./src/component/CheckboxGroup/remark.js